
import CardPropertyTable from '../../components/Card/CardPropertyTable.vue'

export default {
  name: 'VehicleCardPropertyRequisites',
  extends: CardPropertyTable,
  data: () => {
    return {
      hideHeaderLocal: true, // @Override
      hideBottomLocal: true // @Override
    }
  },
  computed: {
    columns: function () {
      const columns = []
      columns.push({ name: 'label', align: 'left', field: 'label', sortable: false })
      columns.push({ name: 'value', align: 'left', field: 'value', sortable: false })
      return columns
    },
    rows: function () {
      const rows = []
      if (this.object && this.tabProp) {
        const propData = this.object[this.tabProp.key]
        if (propData && typeof propData === 'object') {
          rows.push({ label: 'Адрес регистрации', value: propData.address })
          rows.push({ label: 'Телефон', value: propData.contactPhone })
          rows.push({ label: 'ИНН', value: propData.inn })
          rows.push({ label: 'КПП', value: propData.kpp })
          rows.push({ label: 'ОКПО', value: propData.okpo })
          rows.push({ label: 'ОГРН', value: propData.ogrn })
        }
      }
      return rows
    }
  }
}
